import { IKogIcon } from '@/main/@types/interfaceIcons'
import React from 'react'

export function ReturnIcon({
  height = '50px',
  width = '50px',
  color = 'currentColor'
}: IKogIcon) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 442.000000 377.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,377.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path d="M1925 3716 c-359 -53 -685 -206 -958 -449 l-78 -70 -217 215 c-119
          119 -232 224 -251 233 -70 35 -171 15 -228 -47 -52 -56 -54 -81 -51 -638 l3
          -515 25 -50 c18 -37 37 -57 70 -75 l45 -25 510 -3 c281 -2 529 0 551 3 121 17
          203 153 159 260 -12 28 -95 119 -273 298 l-257 257 45 40 c358 318 752 463
          1214 447 253 -8 453 -58 681 -170 258 -127 447 -282 621 -507 278 -359 399
          -867 319 -1330 -47 -271 -214 -617 -391 -810 -278 -303 -574 -477 -931 -550
          -475 -96 -904 -14 -1303 248 -205 135 -390 327 -509 529 -24 40 -49 77 -57 84
          -41 34 -112 -9 -99 -60 22 -87 212 -339 361 -480 347 -326 778 -492 1278 -491
          491 2 1002 234 1328 605 451 512 587 1162 381 1810 -92 289 -277 573 -503 773
          -254 225 -566 382 -896 453 -126 27 -450 35 -589 15z m-1045 -691 c446 -446
          503 -507 503 -534 0 -17 -8 -40 -18 -51 -18 -20 -30 -20 -532 -20 l-514 0 -24
          25 -25 24 0 505 c0 277 3 512 6 521 8 21 60 44 84 38 9 -2 243 -231 520 -508z"
        />
      </g>
    </svg>
  )
}